


import slider1 from "../assets/images/slider1.jpg";
import slider2 from "../assets/images/slider2.jpg";
import slider3 from "../assets/images/slider3.jpg";


export const slider = [
  {
    // title:'“We may live in an urban jungle, but look around, lest we forget our connection to nature”• Translational Ecology: Collected Writings on Contemporary Environmental Issues: Schlesinger, W.H., Hawkins, S.J., Mooney, H.A.',
    title : "Animal Conservation Ecology Lab",
    img: slider1,
  },
  {
    // title:'The only way forward, if we are going to improve the quality of the environment, is to get everybody involved.” – Richard Rogers',
    title : "Animal Conservation Ecology Lab",
    img: slider2,
  },
  {
    // title: '"Once you work with wildlife, you realize all life is precious” - Dr. Bindu Raghavan',
    title : "Animal Conservation Ecology Lab",
    img: slider3,
  },
  {
    // title:'“The greatness of a nation can be judged by the way its animals are treated” - Mahatma Gandhi.',
    title : "Animal Conservation Ecology Lab",
    img: slider2,
  },
];
